import React from 'react'
import Navbar from '../components/Global/Navbar'
import Main from '../components/Search/Main'
import AuthModal from '../components/Modals/AuthModal'

class Search extends React.Component {
	
	constructor(props) {
		super(props);
		this.state = {
			modal: false,
			defaultAuth: true
		};
		this.onLogin = this.onLogin.bind(this);
		this.onSignup = this.onSignup.bind(this);
		this.onClose = this.onClose.bind(this);
		this.onOverlay = this.onOverlay.bind(this);
	}
	
	onLogin() {
		document.body.classList.add('modal-open');
		this.setState({
			modal: true,
			defaultAuth: true
		});
	}
	
	onSignup() {
		document.body.classList.add('modal-open');
		this.setState({
			modal: true,
			defaultAuth: false
		});
	}
		
	onClose() {
		document.body.classList.remove('modal-open');
		this.setState({
			modal: false
		});
	}
	
	onOverlay(e) {
		if (e.target.dataset.modal) {
			this.onClose();
		}
	}
	
	render() {
		
		const { match, location } = this.props
		
		return (
			<div>
				<Navbar onLogin={ this.onLogin } onSignup={ this.onSignup } />
				<Main onLogin={ this.onLogin } pathname={ match } search={ location.search } />
				<AuthModal onOverlay={ this.onOverlay } onClose={ this.onClose } isOpen={ this.state.modal } defaultAuth={ this.state.defaultAuth } transitionName="opacity" />
			</div>
		)
	}
}

export default Search


// WEBPACK FOOTER //
// ./src/containers/Search.js